// src/api/userApi.js
import axiosClient from "./axiosClient";

//Fetch all users (Admin only)
export const getAllUsers = async () => {
  const res = await axiosClient.get("/users/all/");
  return res.data;
};

//Assign or update a user's role
export const assignUserRole = async (userId, roleId) => {
  return axiosClient.post("/users/assign-role/", {
    user_id: userId,
    role_id: roleId,
  });
};

//Fetch all properties a user can access
export const getUserAssignments = async (userId) => {
  const res = await axiosClient.get(`/users/${userId}/assignments/`);
  return res.data;
};

//Update a user's property & unit assignments
export const updateUserAssignments = async (userId, propertyIds, unitIds) => {
  const res = await axiosClient.post(`/users/${userId}/assignments/update/`, {
    property_ids: propertyIds,
    unit_ids: unitIds,
  });
  return res;
};

export const getAllRoles = async () => {
  const res = await axiosClient.get("/roles/");
  return res.data;
};

// Check if token claims need refresh
export const refreshTokenClaims = async () => {
  const res = await axiosClient.post("/auth/refresh-token-claims/");
  return res.data;
};

// Get users for ticket assignment dropdowns (accessible to all authenticated users)
export const getUsersForAssignment = async () => {
  const res = await axiosClient.get("/users/for-assignment/");
  return res.data;
};

// Get users for change request assignment dropdowns (includes IT support users)
export const getUsersForChangeRequests = async () => {
  const res = await axiosClient.get("/users/for-change-requests/");
  return res.data;
};
